import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-category-shield",
  "use": "icon-category-shield-usage",
  "viewBox": "0 0 138 138",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 138 138\" id=\"icon-category-shield\"><path d=\"M46 0L0 68.999 69 138l69-69.001L92 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol